import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router, RouterLink, RouterLinkActive } from "@angular/router";
import { NonDeprecatedKeycloakService as KeycloakService } from '@core/keycloak/non-deprecated-keycloak.service';
import { SecurityRoles } from "@core/auth/security-roles.enum";
import { environment } from "@env/environment";
import { MatDivider, MatList, MatListItem } from "@angular/material/list";
import { MatIcon } from "@angular/material/icon";
import { HasAnyAuthorityDirective } from "@core/auth/has-any-authority.directive";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";

@Component({
  imports: [
    CommonModule,
    MatList,
    MatListItem,
    MatIcon,
    MatDivider,
    HasAnyAuthorityDirective,
    RouterLink,
    RouterLinkActive,
    FlexLayoutModule,
  ],
  standalone: true,
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.scss"],
})
export class NavigationComponent implements OnInit {
  isNavbarCollapsed = false;
  VERWALTUNG_ERFASSUNGSWELLEN = SecurityRoles.VERWALTUNG_ERFASSUNGSWELLEN;
  VERWALTUNG_FRAGEBOEGEN = SecurityRoles.VERWALTUNG_FRAGEBOEGEN;
  VERWALTUNG_FOTOS = SecurityRoles.VERWALTUNG_FOTOS;
  VERWALTUNG_ZAEHLUNGEN = SecurityRoles.VERWALTUNG_ZAEHLUNGEN;
  VERWALTUNG_ANTWORTLISTEN = SecurityRoles.VERWALTUNG_ANTWORTLISTEN;
  VERWALTUNG_FAHRPLAENE = SecurityRoles.VERWALTUNG_FAHRPLAENE;
  VERWALTUNG_ADMIN = SecurityRoles.VERWALTUNG_ADMIN;
  VERWALTUNG_MITTEILUNGEN = SecurityRoles.VERWALTUNG_MITTEILUNGEN;
  version = environment.version;

  constructor(
    private router: Router,
    private keycloakService: KeycloakService
  ) {}

  ngOnInit() {}

  logout() {
    this.keycloakService.logout();
  }

  switchNavbarCollapzation() {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
    localStorage.setItem(
      "isNavbarCollapsed",
      JSON.stringify(this.isNavbarCollapsed)
    );
  }
}
